import { atom } from 'jotai';

export default atom(false);
